import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const createBlockModalSelector = createSelector(modalsSelector, (modals) => modals.createBlock);

export default createBlockModalSelector;
